__webpack_require__.p = "/ownrecipes-web/";